import { render, staticRenderFns } from "./LoopsProteinSelection.vue?vue&type=template&id=f6a35bf4&scoped=true&"
import script from "./LoopsProteinSelection.vue?vue&type=script&lang=js&"
export * from "./LoopsProteinSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a35bf4",
  null
  
)

export default component.exports